import {
  NgModule,
} from '@angular/core';
import {
  CatalogServicesStoreModule,
  UiStatusStoreModule,
} from '@refx/shared-store';
import {
  AddServiceCodeParamGuard,
} from './add-service-code-param.guard';

@NgModule({
  imports: [CatalogServicesStoreModule, UiStatusStoreModule],
  providers: [AddServiceCodeParamGuard]
})
export class AddServiceCodeParamModule {}
